const localURL = "http://localhost:8080";
const devURL = "https://llmaas-datamanager-dev.musea2.azure.ext.gm.com";
const testURL = "https://llmaas-operations-api-tst.musea2.azure.ext.gm.com";
const prodURL = "https://llmaas-operations-api.musea2.azure.ext.gm.com";

const preProdAuth = {
  auth_client_id: "7935186b-7740-41b3-a709-55d35427ca15",
  auth_scope: "api://llmaas-operations.dev.gm.com/.default",
  authority:
    "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
};

const prodAuth = {
  auth_client_id: "941039a8-e399-41bf-89e2-105763d58e29",
  auth_scope: "api://llmaas-operations.gm.com/.default",
  authority:
    "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d",
};

const prodEnv = {
  url: prodURL,
  ...prodAuth,
};

const testEnv = {
  url: testURL,
  ...preProdAuth,
};

const devEnv = {
  url: devURL,
  ...preProdAuth,
};

const localEnv = {
  url: localURL,
  ...preProdAuth,
};

export const getEnv = () => {
  const url = window.location.origin;
  if (url.includes("dev")) {
    return devEnv;
  }
  if (url.includes("tst")) {
    return testEnv;
  }
  if (url.includes("local")) {
    return localEnv;
  }
  return prodEnv;
};
